import { useState, useCallback } from 'react';

/**
 * Hook for honeypot bot protection
 * Creates a hidden field that bots typically fill out automatically
 * If the field has any value, it's likely a bot submission
 */
export const useHoneypot = () => {
  const [honeypotValue, setHoneypotValue] = useState('');
  const [honeypotTimestamp] = useState(() => Date.now());

  const isBot = useCallback(() => {
    // Check 1: Honeypot field should be empty (bots often fill all fields)
    if (honeypotValue.trim() !== '') {
      console.log('Bot detected: honeypot field filled');
      return true;
    }

    // Check 2: Form submitted too quickly (less than 2 seconds)
    const timeDiff = Date.now() - honeypotTimestamp;
    if (timeDiff < 2000) {
      console.log('Bot detected: form submitted too quickly');
      return true;
    }

    return false;
  }, [honeypotValue, honeypotTimestamp]);

  const HoneypotField = useCallback(
    () => (
      <div
        style={{
          position: 'absolute',
          left: '-9999px',
          top: '-9999px',
          opacity: 0,
          height: 0,
          overflow: 'hidden',
        }}
        aria-hidden="true"
        tabIndex={-1}
      >
        <label htmlFor="website_url_field">Website</label>
        <input
          type="text"
          id="website_url_field"
          name="website_url"
          value={honeypotValue}
          onChange={(e) => setHoneypotValue(e.target.value)}
          autoComplete="off"
          tabIndex={-1}
        />
      </div>
    ),
    [honeypotValue]
  );

  return {
    honeypotValue,
    honeypotTimestamp,
    isBot,
    HoneypotField,
  };
};

export default useHoneypot;
